module.exports = __webpack_public_path__ + "static/neworleans-079902a02f5f8154b18e144382532b03.png";